import Outline from "./Outline";

export default Outline;



// WEBPACK FOOTER //
// ./src/components/DocumentV2/Outline/index.js